module.exports = __webpack_public_path__ + "assets/img/order-count-icon2.717ba80b.png";